
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.0007 22C13.1289 22 14.052 21.0769 14.052 19.9487H9.94939C9.94939 21.0769 10.8622 22 12.0007 22ZM18.1546 15.8462V10.7179C18.1546 7.56923 16.4725 4.93333 13.5392 4.2359V3.53846C13.5392 2.68718 12.852 2 12.0007 2C11.1494 2 10.4623 2.68718 10.4623 3.53846V4.2359C7.51868 4.93333 5.84688 7.55897 5.84688 10.7179V15.8462L4.52381 17.1692C3.87765 17.8154 4.32893 18.9231 5.24175 18.9231H18.7494C19.6623 18.9231 20.1238 17.8154 19.4777 17.1692L18.1546 15.8462Z"}})])
          )
        }
      }
    